import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Button, Drawer, Select } from "antd";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import noImage from "../../assets/Images/roundimage.png";
import SearchBox from "../CustomWidgets/SearchBox";
import subscriptionUser from "../../assets/subcriptionUser.svg";
import subscriptionMachine from "../../assets/subscriptionMachine.svg";
import subscriptionCheck from "../../assets/subcriptionCheck.svg";
import FawryLogo from "../../assets/FawryLogo.svg";
import PaymobLogo from "../../assets/PaymobLogo.svg";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip, IconButton } from "@mui/material";
import Navbar from "../Navbar/Navbar";
import {
  DoubleRightOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import { routes } from "../../Routes";
import { getSubstores } from "../../API  Functions/ProfileFunctions";
import { setIsMasterStore } from "../../Redux/Action/loginAction";
import PaymentModal from "./PaymentModal";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { toast } from "react-toastify";

const durationRank = {
  Monthly: 1,
  Quarterly: 2,
  "Half-Yearly": 3,
  Yearly: 4,
};

const RenewPlan = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { plans, subscriptionDetails, page, isrenew } = location.state || {};
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [referenceId, setReferenceId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [couponLoading, setCouponLoading] = useState(false);
  const [usersLoading, setUsersLoading] = useState(true);
  const [selectedType, setSelectedType] = useState(page ? page : "Monthly");
  const [users, setUsers] = useState(0);
  const [devices, setDevices] = useState(0);
  const [ugradePlanDetails, setUpgradePlanDetails] = useState(null);
  const [subscriptionHstory, setSubscriptionHstory] = useState(null);
  const [showUsers, setShowUsers] = useState(false);
  const [showBranches, setShowBranches] = useState(false);
  const [showWarehouse, setShowWarehouses] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [paymentUrl, setPaymmentURL] = useState("");
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [selectedWarehouse, setSelectedWarehouses] = useState([]);
  const [isUpgrade, setIsUpgrade] = useState(!isrenew); // NEW → toggle screen
  const [branches, setBranches] = useState(0);
  const [warehousesCount, setWarehousesCount] = useState(0);
  const [subStores, setSubStores] = useState([]);
  const [allWarehouses, setAllWarehouses] = useState([]);
  const [processType, setProcessType] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [step, setStep] = useState(1);
  const [selectedGateway, setSelectedGateway] = useState(null);
  const [paymentModal, setPaymentModal] = useState(null);
  const [coupon, setCoupon] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const masterStore = useSelector((state) => state.login.masterStore);

  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const selectedPlan = plans[selectedType]; // ✅ monthly or yearly

  const dispatch = useDispatch();

  const activePlanName = subscriptionDetails?.plan_name
    ? subscriptionDetails?.plan_name?.toLowerCase()
    : null;
  const currentActiveUsers = allUsers?.filter((user) => user.active);
  const isPlanActive = subscriptionDetails?.plan_id === plans[selectedType]?.id;

  const endDate = new Date(subscriptionDetails?.plan_end_date);
  const today = new Date();

  // Calculate remaining days
  const diffTime = endDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  useEffect(() => {
    GetAllUsers();
    getSubStoresData();
  }, []);

  useEffect(() => {
    // if (isUpgrade) {
    GetSubscriptionUpgradePlans(null);

    // } else {
    // }
  }, [selectedType, isUpgrade]);

  useEffect(() => {
    // if (isUpgrade) {

    const showUsercount =
      isPlanActive && diffDays > 2
        ? 0
        : subscriptionDetails?.additional_no_of_user;
    const showBranchcount =
      isPlanActive && diffDays > 2
        ? 0 : subscriptionDetails?.no_of_branch;
        // : subStores?.length > selectedPlan?.no_of_branch
        // ? subStores?.length - selectedPlan?.no_of_branch
        // : 0;
    const showWarehousecount =
      isPlanActive && diffDays > 2
        ? 0 : subscriptionDetails?.no_of_warehouse;
        // : allWarehouses?.length > selectedPlan?.no_of_warehouse
        // ? allWarehouses?.length - selectedPlan?.no_of_warehouse
        // : 0;

    setUsers((showUsercount < 0 ? 0 : showUsercount)|| 0);
    setBranches((showBranchcount < 0 ? 0 : showBranchcount) || 0);
    setWarehousesCount((showWarehousecount < 0 ? 0 : showWarehousecount) || 0);
console.log("showUsercount==>",showUsercount);

    // } else {
    // }
  }, [selectedType, subscriptionDetails, allUsers, subStores, allWarehouses]);

  const getSubStoresData = () => {
    const companyID = masterStore ? masterStore?.store_id : company_id;
    getSubstores(companyID).then((res) => {
      // console.log("USERRRRR---> Res", res);

      // const activeBranch = res?.response.filter(
      //   (user) => user.active === true
      // );

      setSubStores(res?.response.filter((item) => item.is_warehouse === false));
      setSelectedBranches(
        res?.response.filter((item) => item.is_warehouse === false)
      );

      setAllWarehouses(
        res?.response.filter((item) => item.is_warehouse === true)
      );
      setSelectedWarehouses(
        res?.response.filter((item) => item.is_warehouse === true)
      );

      // console.log("active---> Res", res?.response);
    });
  };

  const GetAllUsers = async () => {
    try {
      setUsersLoading(true);
      const res1 = await getStoreUsers(user_id, true);

      if (res1?.result[0]?.status_code === 200) {
        const responseUsers = res1.result[0]?.response || [];

        // Filter out inactive users AND admins
        const activeUsers = responseUsers.filter(
          (user) => user.active === true && user.user_type !== "admin"
        );

        // Keep all users except admins
        const nonAdminUsers = responseUsers.filter(
          (user) => user.user_type !== "admin"
        );

        setAllUsers(nonAdminUsers);
        setSelectedUsers(activeUsers);
      } else {
        setAllUsers([]);
        setSelectedUsers([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      const showUsercount =
        isPlanActive && diffDays > 2
          ? 0
          : subscriptionDetails?.additional_no_of_user;
      const showBranchcount =
        isPlanActive && diffDays > 2
          ? 0 : subscriptionDetails?.no_of_branch;
          // : subStores?.length > selectedPlan?.no_of_branch
          // ? subStores?.length - selectedPlan?.no_of_branch
          // : 0;
      const showWarehousecount =
        isPlanActive && diffDays > 2
          ? 0 : subscriptionDetails?.no_of_warehouse;
          // : allWarehouses?.length > selectedPlan?.no_of_warehouse
          // ? allWarehouses?.length - selectedPlan?.no_of_warehouse
          // : 0;
      setUsers((showUsercount < 0 ? 0 : showUsercount) || 0);
      setBranches((showBranchcount < 0 ? 0 : showBranchcount) || 0);
      setWarehousesCount((showWarehousecount < 0 ? 0 : showWarehousecount) || 0);

      // } else {

      // setUsers(showUsercount < 0 ? 0 : showUsercount);
      // setBranches(showBranchcount < 0 ? 0 : showBranchcount);
      // } else {
    } finally {
      setUsersLoading(false); // this should be false, not true
    }
  };

  const GetSubscriptionUpgradePlans = async (couponID) => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        URLS.GET_SUBSCRIPTION_UPGRADE_PLANS,
        {
          lang: i18n.language === "ar" ? "ar_001" : "en_US",
          retailer_id: company_id,
          plan_id: selectedPlan?.id,
          // coupon_id: couponID ? couponID : null,
        }
      );
      // console.log("GetSubscriptionUpgradePlans===>", response?.data);

      if (response?.data?.result?.status_code == 200) {
        setUpgradePlanDetails(response?.data?.result);
      } else {
        setUpgradePlanDetails([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // Handle User Counter
  const handleUserChange = (type) => {
    setUsers((prev) =>
      type === "inc" ? prev + 1 : prev > 0 ? prev - 1 : prev
    );
  };
  const handleDeviceChange = (type) => {
    setDevices((prev) =>
      type === "inc" ? prev + 1 : prev > 0 ? prev - 1 : prev
    );
  };

  const handleBranchChange = (type) => {
    setBranches((prev) =>
      type === "inc" ? prev + 1 : prev > 0 ? prev - 1 : prev
    );
  };

  const handleWarehouseChange = (type) => {
    setWarehousesCount((prev) =>
      type === "inc" ? prev + 1 : prev > 0 ? prev - 1 : prev
    );
  };

  // The cost for adding branches
  const additionalBranchCost = isUpgrade
    ? ugradePlanDetails?.additional_per_branch_price
    : selectedPlan?.per_branch_price;

  // Payment API

  const handlePaymobPayment = (method, type) => {
    if (type == "renew") {
      handlePayment(method, "payMob");
    } else if (type == "upgrade") {
      handleUpgradePayment(method, "payMob");
    } else if (type == "addFeatures") {
      handleUpgradeUsersandMachinesPayment(method, "payMob");
    }
  };

  const handleFawryPayment = (method, type) => {
    if (type == "renew") {
      handlePayment(null, "fawry");
    } else if (type == "upgrade") {
      handleUpgradePayment(null, "fawry");
    } else if (type == "addFeatures") {
      handleUpgradeUsersandMachinesPayment(null, "fawry");
    }
  };

  const handlePayment = async (method, gateway) => {
    try {
      setLoading(true);
      const selectedPlan = plans[selectedType]; // monthly or yearly
      const userIds = selectedUsers?.map((user) => user.retailer_user_id);
      const branchIds = selectedBranches?.map((user) => user.store_id);
      const warehousesIds = selectedWarehouse?.map((user) => user.store_id);
      const response = await axiosInstance.post(
        gateway == "fawry"
          ? URLS.RETAILER_FAWRT_PAYMENT
          : URLS.RETAILER_PAYMOB_PAYMENT,
        {
          retailer_id: company_id,
          plan_id: selectedPlan?.id, // send the correct id
          user_list: userIds,
          branch_ids: branchIds,
          warehouse_ids: warehousesIds,
          no_of_user: users,
          no_of_device: devices,
          no_of_branch: branches,
          no_of_warehouse: warehousesCount,
          coupon_id: appliedCoupon?.coupon_id ? appliedCoupon?.coupon_id : null,
          // is_renew: true,
          is_renew:
            subscriptionDetails?.status === "active" &&
            subscriptionDetails?.plan_id &&
            diffDays <= 2
              ? true
              : false,
          additional_price:
            users * selectedPlan?.per_user_price +
            branches * selectedPlan?.per_branch_price +
            warehousesCount * selectedPlan?.per_warehouse_price +
            devices * selectedPlan?.per_device_monthly_amount +
            devices * selectedPlan?.per_device_security_deposit +
            selectedPlan?.security_deposit,
          ...(gateway == "payMob" && { payment_method: method }),
        }
      );

      if (
        response?.data?.result?.status_code === 200 ||
        response?.data?.result?.Status === 200
      ) {
        if (gateway == "fawry") {
          setReferenceId(response?.data?.result?.["Refrence-Number"]);
          setStep(3);
        } else {
          const checkoutUrl = response?.data?.result?.unifiedcheckout_url;
          // window.open(checkoutUrl, "_blank", "noopener,noreferrer");
          window.open(checkoutUrl, "_self");

          setPaymmentURL(checkoutUrl);
          // setPaymentModal(true)
          setShowModal(false);
          setStep(4);
        }

        // setReferenceId(response?.data?.result?.["Refrence-Number"]);
        // setShowModal(true);
      } else {
        setReferenceId("");
        setPaymmentURL("");
      }
    } catch (error) {
      console.error("Payment failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpgradeUsersandMachinesPayment = async (method, gateway) => {
    try {
      setLoading(true);
      const selectedPlan = plans[selectedType]; //  monthly or yearly
      // const userIds = selectedUsers?.map((user) => user.retailer_user_id);
      // const branchIds = selectedBranches?.map((user) => user.store_id);
      // const warehousesIds = selectedWarehouse?.map((user) => user.store_id);
      const response = await axiosInstance.post(
        gateway == "fawry"
          ? URLS.UPGRADE_USERS_OR_DEVICE
          : URLS.UPGRADE_USERS_OR_DEVICE_PAYMOB,
        {
          lang: "en_US",
          retailer_id: company_id,
          plan_id: selectedPlan?.id, // send the correct id
          no_of_user: users,
          no_of_device: devices,
          no_of_branch: branches,
          no_of_warehouse: warehousesCount,
          // branch_ids: branchIds,
          // warehouse_ids: warehousesIds,
          // user_list: userIds,
          final_price:
            ((users * selectedPlan?.per_user_price) /
              subscriptionDetails?.days) *
              diffDays +
            ((branches * selectedPlan?.per_branch_price) /
              subscriptionDetails?.days) *
              diffDays +
            ((warehousesCount * selectedPlan?.per_warehouse_price) /
              subscriptionDetails?.days) *
              diffDays +
            ((devices * selectedPlan?.per_device_monthly_amount) /
              subscriptionDetails?.days) *
              diffDays +
            devices * selectedPlan?.per_device_security_deposit,
          ...(gateway == "payMob" && { payment_method: method }),
        }
      );

      if (response?.data?.result?.status_code === 200) {
        if (gateway == "fawry") {
          setReferenceId(response?.data?.result?.fawryRefNumber);

          setStep(3);
        } else {
          const checkoutUrl = response?.data?.result?.unifiedcheckout_url;
          // window.open(checkoutUrl, "_blank", "noopener,noreferrer");
          window.open(checkoutUrl, "_self");

          setPaymmentURL(checkoutUrl);
          //  setPaymentModal(true)
          setShowModal(false);
          setStep(4);
        }
      } else {
        setReferenceId("");
      }
    } catch (error) {
      console.error("Payment failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpgradePayment = async (method, gateway) => {
    try {
      setLoading(true);
      const selectedPlan = plans[selectedType]; // monthly or yearly
      console.log("selectedPlan==>", selectedPlan);
      const userIds = selectedUsers?.map((user) => user.retailer_user_id);
      const branchIds = selectedBranches?.map((user) => user.store_id);
      const warehousesIds = selectedWarehouse?.map((user) => user.store_id);

      const response = await axiosInstance.post(
        gateway == "fawry" ? URLS.UPGRADE_PLAN : URLS.UPGRADE_PLAN_PAYMOB,
        {
          retailer_id: company_id,
          new_plan_id: ugradePlanDetails?.new_plan_id, // send the correct id
          lang: i18n.language === "ar" ? "ar_001" : "en_US",
          no_of_user: users,
          branch_ids: branchIds,
          warehouse_ids: warehousesIds,
          no_of_device: devices,
          no_of_branch: branches,
          no_of_warehouse: warehousesCount,
          user_list: userIds,
          coupon_id: appliedCoupon?.coupon_id ? appliedCoupon?.coupon_id : null,
          new_plan_price:
            ugradePlanDetails?.new_plan_price +
            // selectedPlan?.security_deposit +
            // ugradePlanDetails?.new_plan_price +
            branches * ugradePlanDetails?.additional_per_branch_price +
            warehousesCount *
              ugradePlanDetails?.additional_per_warehouse_price +
            users * ugradePlanDetails?.additional_per_user_price +
            devices * ugradePlanDetails?.additional_per_device_price +
            devices * ugradePlanDetails?.additional_per_device_security_deposit,
          ...(gateway == "payMob" && { payment_method: method }),
        }
      );

      if (response?.data?.result?.status_code === 200) {
        if (gateway == "fawry") {
          setReferenceId(response?.data?.result?.fawryRefNumber);

          setStep(3);
        } else {
          const checkoutUrl = response?.data?.result?.unifiedcheckout_url;
          // window.open(checkoutUrl, "_blank", "noopener,noreferrer");
          window.open(checkoutUrl, "_self");

          setPaymmentURL(checkoutUrl);
          //  setPaymentModal(true)
          setShowModal(false);
          setStep(4);
        }
      } else {
        setReferenceId("");
      }
    } catch (error) {
      console.error("Payment failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const parseDescription = (desc) =>
    desc
      .split("\n")
      .filter((line) => line.trim() !== "")
      .map((line) => line.replace("✅", "").trim());

  const benefits = selectedPlan
    ? selectedPlan?.description
      ? parseDescription(selectedPlan?.description)
      : []
    : [];

  const baseUsers =
    (isUpgrade || diffDays <= 2
      ? selectedPlan?.no_of_user
      : subscriptionDetails?.status === "active"
      ? subscriptionDetails?.no_of_user
      : selectedPlan?.no_of_user) *
    (allWarehouses?.length + subStores?.length + 1);

  const baseBranches =
    isUpgrade || diffDays <= 2
      ? selectedPlan?.no_of_branch
      : subscriptionDetails?.status === "active"
      ? subscriptionDetails?.no_of_branch
      : selectedPlan?.no_of_branch;

  const baseWarehouse =
    isUpgrade || diffDays <= 2
      ? selectedPlan?.no_of_warehouse
      : subscriptionDetails?.status === "active"
      ? subscriptionDetails?.no_of_warehouse
      : selectedPlan?.no_of_warehouse;

  const totalUsers = baseUsers + users;

  const totalBranches = baseBranches + branches;
  const totalWareHouses = baseWarehouse + warehousesCount;
console.log("totalWareHouses==>",totalWareHouses);

  const totalUpdatePrice =
    (isUpgrade ? ugradePlanDetails?.new_plan_price : selectedPlan?.cost) +
    (isUpgrade ? 0 : selectedPlan?.security_deposit) +
    users *
      (isUpgrade
        ? ugradePlanDetails?.additional_per_user_price
        : selectedPlan?.per_user_price) +
     warehousesCount *
      (isUpgrade
        ? ugradePlanDetails?.additional_per_warehouse_price
        : selectedPlan?.per_warehouse_price) +
    branches *
      (isUpgrade
        ? ugradePlanDetails?.additional_per_branch_price
        : selectedPlan?.per_branch_price) +
    devices *
      (isUpgrade
        ? ugradePlanDetails?.additional_per_device_price
        : selectedPlan?.per_device_monthly_amount) +
    devices *
      (isUpgrade
        ? ugradePlanDetails?.additional_per_device_security_deposit
        : selectedPlan?.per_device_security_deposit);

        console.log("totalUpdatePrice===>",totalUpdatePrice);
        
  const couponDiscount = appliedCoupon?.coupon_id
    ? appliedCoupon.price_type === "percentage"
      ? (selectedPlan?.cost *
          appliedCoupon.price) /
        100
      : appliedCoupon.price
    : 0;


  //       const handleApply = () => {
  //   if (!coupon.trim()) return;
  //   setAppliedCoupon(coupon.toUpperCase());
  //   setCoupon("");
  // };

  const handleApply = async () => {
    if (!coupon.trim()) return;

    setCouponLoading(true);

    try {
      const res = await axiosInstance.post(URLS.CHECK_SUBSCRIPTION_COUPON, {
        retailer_id: company_id,
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
        coupon_code: coupon,
      });
      console.log("responce of coupon===>", res?.data);

      if (res?.data?.result?.status_code == 200) {
        if(res?.data?.result?.data[0]?.price <= selectedPlan?.cost){
  setAppliedCoupon(res.data?.result?.data[0]); // 🔥 save full coupon details
        setCoupon("");
        }else{
          toast.error(t("Coupon value exceeds the plan price."));
        }
      
      } else {
        toast.error(t("Invalid coupon code"));
      }
    } catch (err) {
    } finally {
      setCouponLoading(false);
    }
  };

  const handleRemove = () => {
    setAppliedCoupon(null);
    //  GetSubscriptionUpgradePlans(null)
  };

  const billingRank = {
    Monthly: 1,
    Quarterly: 2,
    "Half-Yearly": 3,
    Yearly: 4,
  };

  const gateways = [
    {
      id: "Fawry",
      name: "Fawry",
      logo: (
        <img
          className="w-13 h-13 object-contain "
          src={FawryLogo}
          alt="Fawry icon"
        />
      ), // Replace with <img src="/fawry-logo.png" /> if you have it
    },
    {
      id: "PayMob",
      name: "PayMob",
      logo: (
        <img
          className="w-13 h-13 object-contain "
          src={PaymobLogo}
          alt="Paymob icon"
        />
      ), // Replace with <img src="/paymob-logo.png" /> if available
    },
  ];

  return (
    <>
      <div className="w-full flex flex-col md:h-full  bg-gradient-to-bl from-[#F7EEC4] to-gray-50">
        <Navbar heading="Subscription" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden w-full">
          <div className="flex justify-start ms-4">
            <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: (
                    <Link to={routes.settings.subscription}>
                      {t("Subscription")}
                    </Link>
                  ),
                  key: "subscription",
                },
                { title: t("Plan Details") },
              ]}
              className="relative mt-3 font-semibold"
            />
          </div>

          <div className=" flex flex-col items-center min-h-screen p-6 bg-gradient-to-bl from-[#F7EEC490] to-gray-50">
            {Object.keys(plans).length > 1 && (
              <div className="flex bg-gray-200 rounded-full p-1 mb-3">
                {Object.keys(plans).map((billingType) => (
                  <button
                    disabled={
                      subscriptionDetails?.status === "active" &&
                      billingRank[subscriptionDetails?.billing_type] >
                        billingRank[billingType]
                    }
                    key={billingType}
                    onClick={() => setSelectedType(billingType)}
                    className={`px-6 py-2 rounded-full font-medium disabled:opacity-50 transition ${
                      selectedType === billingType
                        ? "bg-gray-800 text-white"
                        : "text-gray-600"
                    }`}
                  >
                    {t(billingType)}
                  </button>
                ))}
              </div>
            )}

            <h1 className="text-xl font-bold self-start mb-2">
              {isUpgrade
                ? t("Upgrade Plan")
                : isPlanActive && diffDays > 2
                ? t("Add Additional Fetaures")
                : ""}
            </h1>

            {/* Main White Box */}
            <div className="bg-white rounded-2xl shadow-sm p-4 w-full">
              <div className="grid md:grid-cols-2 gap-4">
                {/* Header */}
                <div>
                  <div className=" border border-[#E3E7EF] p-4 rounded-2xl">
                    <div className="flex justify-between items-center mb-3 border-b-2 border-[#C6C6C666] pb-3">
                      <div>
                        <h2 className="text-lg font-semibold">
                          <span className="uppercase">
                            {t(plans[selectedType]?.plan_name)}
                          </span>{" "}
                          <span className="font-normal text-gray-500">
                            ({t(plans[selectedType]?.billing_type)})
                          </span>
                        </h2>
                        <p className="text-xl font-bold  mt-2">
                          EGP {plans[selectedType]?.cost}
                        </p>
                      </div>
                      {subscriptionDetails?.status == "active" &&
                        subscriptionDetails?.plan_id ===
                          plans[selectedType]?.id && (
                          <span className="bg-green-500 text-white text-sm px-3 py-1 rounded-full font-semibold">
                            {t("Active")}
                          </span>
                        )}
                    </div>

                    {/* Users and Machines */}
                    <div className="flex gap-x-2 mb-5 mt-4">
                      <div className=" rounded-sm bg-primaryBlue px-3 py-1 text-sm text-white font-semibold">
                        <span>
                          {t("Users Included")}: {selectedPlan?.no_of_user}
                        </span>
                      </div>
                      {selectedPlan.no_of_device > 0 && (
                        <div className=" rounded-sm bg-primaryBlue px-3 py-1 text-sm text-white font-semibold">
                          <span>
                            {t("Machines Included")}:{" "}
                            {selectedPlan?.no_of_machine || 1}
                          </span>
                        </div>
                      )}

                      {selectedPlan.no_of_warehouse > 0 && (
                        <div className=" rounded-sm bg-primaryBlue px-3 py-1 text-sm text-white font-semibold">
                          <span>
                            {t("Warehouses Included")}:{" "}
                            {selectedPlan?.no_of_warehouse || 1}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Middle Section: Choose Plan + Renewal Details */}
                    <h3 className="text-sm font-semibold mb-3">
                      {t("Plan Benefits")}
                    </h3>
                    <ul className="space-y-2 mb-2">
                      {benefits?.map((benefit, idx) => (
                        <li
                          key={idx}
                          className="flex items-center gap-2 text-sm text-gray-700"
                        >
                          <img
                            className="w-5 h-5 object-contain"
                            src={subscriptionCheck}
                            alt="Minus icon"
                          />
                          <span>{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  {!(isPlanActive && diffDays > 2) && (
                    <div className="space-y-4 mt-3 w-full">
                      {/* Apply Coupon Box */}
                      {!appliedCoupon && (
                        <div className="border border-[#E3E7EF] p-4 rounded-2xl bg-white">
                          <p className="text-sm font-semibold text-gray-800 mb-2">
                            {t("Apply Coupon")}
                          </p>

                          <div className="flex gap-2">
                            <input
                              value={coupon}
                              onChange={(e) => {
    const value = e.target.value
      .replace(/[^a-zA-Z0-9]/g, '') // allow only letters & digits
      .toUpperCase();               // convert to uppercase

    setCoupon(value);
  }}
                              placeholder={t("Enter coupon code")}
                              className="flex-1 border border-[#E3E7EF] rounded-xl px-4 py-2 outline-none  "
                            />

                            <button
                              disabled={coupon == ""}
                              onClick={handleApply}
                              className="bg-primaryBlue text-white px-6 py-2 rounded-xl font-medium disabled:opacity-50"
                            >
                              {couponLoading ? (
                                <LoadingOutlined style={{ color: "#fff" }} />
                              ) : (
                                t("Apply")
                              )}
                            </button>
                          </div>
                        </div>
                      )}

                      {/* Coupon Applied UI */}
                      {appliedCoupon?.coupon_id && (
                        <div className="border border-[#E3E7EF] p-4 rounded-2xl bg-[#F9FAFC] flex items-center justify-between">
                          <div>
                            <p className="text-sm text-green-600 font-semibold">
                              {t("Coupon Applied")} 🎉
                            </p>
                            <p className="text-base font-bold text-gray-900">
                              {appliedCoupon?.coupon_code}
                            </p>
                            <p className="text-xs text-gray-500">
                              {t("Discount successfully applied to your order")}
                            </p>
                          </div>

                          <button
                            onClick={handleRemove}
                            className="text-sm text-red-500 font-medium hover:underline"
                          >
                            {t("Remove")}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Right: Renewal Details + Add User */}
                <div className=" border border-[#E3E7EF] p-4 rounded-2xl">
                  <div className="inline-block mb-6 my-3 mx-2 ">
                    <span className="px-4 py-2  text-sm font-semibold text-[#B08D15] border border-yellow-400 rounded-full bg-yellow-50">
                      {t("Additional Feature")}
                    </span>
                  </div>

                  {/* Add User */}
                  <div className="flex items-center justify-between mb-6 mt-4">
                    {/* Left side */}
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-50">
                        <img
                          className="w-5 h-5 object-contain "
                          src={subscriptionUser}
                          alt="Minus icon"
                        />
                      </div>
                      <div>
                        <p className="font-medium">
                          {t("Buy Additional Users")}
                        </p>
                        <p className="text-xs text-[#111111]">
                          {`${t("Additional User will cost")} EGP ${
                            isUpgrade
                              ? ugradePlanDetails?.additional_per_user_price
                              : selectedPlan?.per_user_price
                          }/${t("User")}`}
                        </p>
                      </div>
                    </div>

                    {/* Counter */}
                    {users > 0 ? (
                      <div className="flex items-center">
                        <button
                          onClick={() => handleUserChange("dec")}
                          className={`w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg ${
                            i18n.language === "ar" ? "" : "me-2"
                          }`}
                          // className="w-8 h-8 flex me-2 items-center justify-center rounded-full bg-primaryBlue text-white text-lg"
                        >
                          −
                        </button>
                        <span className="font-semibold mx-4">{users}</span>
                        <button
                          onClick={() => handleUserChange("inc")}
                          className="w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg"
                        >
                          +
                        </button>
                      </div>
                    ) : (
                      <div
                        onClick={() => handleUserChange("inc")}
                        className=" border border-[#1B4597] bg-[#F5F7FA] text-primaryBlue rounded-md py-1 px-4  font-medium cursor-pointer"
                      >
                        <span>{t("Add")}</span>
                      </div>
                    )}
                  </div>

                  {/* Add Branch */}
                  {selectedPlan?.no_of_branch > 0 && (
                    <div className="flex items-center justify-between mb-6">
                      {/* Left side */}
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-50">
                          <ShopOutlined />
                          {/* <img className="w-5 h-5 object-contain" src={subscriptionUser} alt="Branch Icon" /> */}
                        </div>

                        <div>
                          <p className="font-medium">
                            {t("Buy Additional Branches")}
                          </p>
                          <p className="text-xs text-[#111111]">
                            {`${t("Additional Branch will cost")} EGP ${
                              isUpgrade
                                ? ugradePlanDetails?.additional_per_branch_price
                                : selectedPlan?.per_branch_price
                            }/${t("Branch")}`}
                          </p>
                        </div>
                      </div>

                      {/* Counter */}
                      {branches > 0 ? (
                        <div className="flex items-center">
                          <button
                            onClick={() => handleBranchChange("dec")}
                            // className="w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg"
                            className={`w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg ${
                              i18n.language === "ar" ? "" : "me-2"
                            }`}
                          >
                            −
                          </button>
                          <span className="font-semibold mx-4">{branches}</span>
                          <button
                            onClick={() => handleBranchChange("inc")}
                            className="w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg"
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <div
                          onClick={() => handleBranchChange("inc")}
                          className="border border-[#1B4597] bg-[#F5F7FA] text-primaryBlue rounded-md py-1 px-4 font-medium cursor-pointer"
                        >
                          <span>{t("Add")}</span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Add Branch */}
                  {selectedPlan?.no_of_warehouse > 0 && (
                    <div className="flex items-center justify-between mb-6">
                      {/* Left side */}
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-50">
                          <ShopOutlined />
                          {/* <img className="w-5 h-5 object-contain" src={subscriptionUser} alt="Branch Icon" /> */}
                        </div>

                        <div>
                          <p className="font-medium">
                            {t("Buy Additional Warehouses")}
                          </p>
                          <p className="text-xs text-[#111111]">
                            {`${t("Additional Warehouse will cost")} EGP ${
                              isUpgrade
                                ? ugradePlanDetails?.additional_per_warehouse_price
                                : selectedPlan?.per_warehouse_price
                            }/${t("Warehouse")}`}
                          </p>
                        </div>
                      </div>

                      {/* Counter */}
                      {warehousesCount > 0 ? (
                        <div className="flex items-center">
                          <button
                            onClick={() => handleWarehouseChange("dec")}
                            // className="w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg"
                            className={`w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg ${
                              i18n.language === "ar" ? "" : "me-2"
                            }`}
                          >
                            −
                          </button>
                          <span className="font-semibold mx-4">
                            {warehousesCount}
                          </span>
                          <button
                            onClick={() => handleWarehouseChange("inc")}
                            className="w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg"
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <div
                          onClick={() => handleWarehouseChange("inc")}
                          className="border border-[#1B4597] bg-[#F5F7FA] text-primaryBlue rounded-md py-1 px-4 font-medium cursor-pointer"
                        >
                          <span>{t("Add")}</span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Add Device */}
                  {selectedPlan.no_of_device > 0 && (
                    <div className="flex items-center justify-between">
                      {/* Left side */}
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-50">
                          <img
                            className="w-5 h-5 object-contain "
                            src={subscriptionMachine}
                            alt="Minus icon"
                          />
                        </div>

                        <div>
                          <p className="font-medium">
                            {t("Buy Additional Machines")}
                          </p>
                          <p className="text-xs text-[#111111]">
                            {`${t("Additional Machine will cost")} EGP ${
                              isUpgrade
                                ? ugradePlanDetails?.additional_per_device_price
                                : selectedPlan?.per_device_monthly_amount
                            }/${t("Device")}`}
                          </p>
                        </div>
                      </div>

                      {/* Counter */}
                      {devices > 0 ? (
                        <div className="flex items-center">
                          <button
                            onClick={() => handleDeviceChange("dec")}
                            className={`w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg ${
                              i18n.language === "ar" ? "" : "me-2"
                            }`}
                            // className="w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg"
                          >
                            −
                          </button>
                          <span className="font-semibold mx-4">{devices}</span>
                          <button
                            onClick={() => handleDeviceChange("inc")}
                            className="w-8 h-8 flex items-center justify-center rounded-full bg-primaryBlue text-white text-lg"
                          >
                            +
                          </button>
                        </div>
                      ) : (
                        <div
                          onClick={() => handleDeviceChange("inc")}
                          className=" border border-[#1B4597] bg-[#F5F7FA] text-primaryBlue rounded-md py-1 px-4  font-medium cursor-pointer"
                        >
                          <span>{t("Add")}</span>
                        </div>
                      )}
                    </div>
                  )}
                  {(isUpgrade || diffDays <= 2) &&
                    currentActiveUsers?.length > totalUsers && (
                      <div className=" flex mt-7">
                        <span
                          onClick={() => setShowUsers(true)}
                          className=" cursor-pointer text-sm font-medium border rounded-sm  mx-3 px-3 py-1 border-primaryBlue text-primaryBlue"
                        >
                          {t("Manage Users")}
                        </span>
                      </div>
                    )}
                </div>
              </div>
              {/* {subscriptionDetails?.status == "active" && (
          <> */}
              <div className="bg-[#EFF6FF] rounded-2xl py-5 px-4 mt-4">
                {/* Continue Button */}

                <h3 className="text-lg font-semibold mb-2 ">
                  {t("Plan Summary")}
                </h3>
                {subscriptionDetails?.status == "active" &&
                  subscriptionDetails?.plan_id && (
                    <>
                      {" "}
                      <h3 className="text-sm font-semibold mb-2 mt-4 text-primaryBlue">
                        {t("Current Plan Details")}
                      </h3>
                      <div>
                        <div className="flex justify-between mb-2">
                          <span className=" text-sm font-medium">
                            {t("Plan Type")}
                          </span>
                          <span className=" text-sm font-medium">
                            {t(subscriptionDetails?.duration || "-")}
                          </span>
                        </div>
                        {subscriptionDetails?.plan_start_date && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {t("Start Date")}
                            </span>
                            <span className=" text-sm font-medium">
                              {t(subscriptionDetails?.plan_start_date)}
                            </span>
                          </div>
                        )}
                        {subscriptionDetails?.plan_end_date && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {t("End Date")}
                            </span>
                            <span className=" text-sm font-medium">
                              {t(subscriptionDetails?.plan_end_date)}
                            </span>
                          </div>
                        )}

                        {subscriptionDetails?.no_of_user > 0 && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {t("No. of Users")}
                            </span>
                            <span className=" text-sm font-medium">
                              {t(subscriptionDetails?.no_of_user)}
                            </span>
                          </div>
                        )}
                        {subscriptionDetails?.no_of_branch > 0 && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {t("No. of Branches")}
                            </span>
                            <span className=" text-sm font-medium">
                              {t(subscriptionDetails?.no_of_branch)}
                            </span>
                          </div>
                        )}
                        {subscriptionDetails?.no_of_warehouse > 0 && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {t("No. of Warehouses")}
                            </span>
                            <span className=" text-sm font-medium">
                              {t(subscriptionDetails?.no_of_warehouse)}
                            </span>
                          </div>
                        )}
                        {subscriptionDetails?.no_of_device > 0 && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {t("No. of Machines")}
                            </span>
                            <span className=" text-sm font-medium">
                              {t(subscriptionDetails?.no_of_device)}
                            </span>
                          </div>
                        )}
                      </div>
                    </>
                  )}

                {isPlanActive && diffDays > 2 ? (
                  <>
                    {!(
                      users * selectedPlan?.per_user_price === 0 &&
                      devices * selectedPlan?.per_device_monthly_amount === 0 &&
                      branches * selectedPlan?.per_branch_price === 0 &&
                      warehousesCount * selectedPlan?.per_warehouse_price ===
                        0 &&
                      devices * selectedPlan?.per_device_security_deposit === 0
                    ) && (
                      <>
                        <h3 className="text-sm font-semibold mb-2 mt-4 text-primaryBlue">
                          {t("Additional Feature Details")}
                        </h3>

                        {/* Add-on users */}
                        {users * selectedPlan?.per_user_price !== 0 && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {`${t("Add-on users")} (${users})`}
                            </span>
                            <span className=" text-sm font-medium">
                              EGP{" "}
                              {(
                                ((users * selectedPlan?.per_user_price) /
                                  subscriptionDetails?.days) *
                                diffDays
                              ).toFixed(2)}
                            </span>
                          </div>
                        )}

                        {branches * selectedPlan?.per_branch_price !== 0 && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {`${t("Add-on branches")} (${branches})`}
                            </span>
                            <span className=" text-sm font-medium">
                              EGP{" "}
                              {(
                                ((branches * selectedPlan?.per_branch_price) /
                                  subscriptionDetails?.days) *
                                diffDays
                              ).toFixed(2)}
                            </span>
                          </div>
                        )}
                        {warehousesCount * selectedPlan?.per_warehouse_price !==
                          0 && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {`${t("Add-on warehouses")} (${warehousesCount})`}
                            </span>
                            <span className=" text-sm font-medium">
                              EGP{" "}
                              {(
                                ((warehousesCount *
                                  selectedPlan?.per_warehouse_price) /
                                  subscriptionDetails?.days) *
                                diffDays
                              ).toFixed(2)}
                            </span>
                          </div>
                        )}

                        {/* Add-on machines */}
                        {devices * selectedPlan?.per_device_monthly_amount !==
                          0 && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {`${t("Add-on machines")} (${devices})`}
                            </span>
                            <span className=" text-sm font-medium">
                              EGP{" "}
                              {(
                                ((devices *
                                  selectedPlan?.per_device_monthly_amount) /
                                  subscriptionDetails?.days) *
                                diffDays
                              ).toFixed(2)}
                            </span>
                          </div>
                        )}

                        {/* Security deposit */}
                        {devices * selectedPlan?.per_device_security_deposit !==
                          0 && (
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {t("Additional Machine Security Deposit")}
                            </span>
                            <span className=" text-sm font-medium">
                              EGP{" "}
                              {(
                                devices *
                                selectedPlan?.per_device_security_deposit
                              ).toFixed(2)}
                            </span>
                          </div>
                        )}
                      </>
                    )}
                    {users * selectedPlan?.per_user_price +
                      branches * selectedPlan?.per_branch_price +
                      warehousesCount * selectedPlan?.per_warehouse_price +
                      devices * selectedPlan?.per_device_monthly_amount +
                      devices * selectedPlan?.per_device_security_deposit !=
                      0 && (
                      <div className="flex justify-between mt-3 border-t-2 pt-2 border-[#C6C6C680]">
                        <span className=" text-base font-semibold">
                          {t("Amount to Pay")}
                          {/* {isUpgrade &&  */}
                          <Tooltip
                            title={t(
                              "This is the total amount you need to pay including all charges"
                            )}
                          >
                            <IconButton size="small" className="p-0">
                              <InfoOutlinedIcon
                                fontSize="small"
                                sx={{ color: "#383636" }}
                              />
                            </IconButton>
                          </Tooltip>
                          {/* } */}
                        </span>
                        <span className=" text-base font-semibold">
                          EGP{" "}
                          {(
                            ((users * selectedPlan?.per_user_price) /
                              subscriptionDetails?.days) *
                              diffDays +
                            ((branches * selectedPlan?.per_branch_price) /
                              subscriptionDetails?.days) *
                              diffDays +
                            ((warehousesCount *
                              selectedPlan?.per_warehouse_price) /
                              subscriptionDetails?.days) *
                              diffDays +
                            ((devices *
                              selectedPlan?.per_device_monthly_amount) /
                              subscriptionDetails?.days) *
                              diffDays +
                            devices * selectedPlan?.per_device_security_deposit
                          )?.toFixed(2)}
                        </span>
                      </div>
                    )}

                    {/* )} */}
                  </>
                ) : (
                  <>
                    {isUpgrade ? (
                      <>
                        <h3 className="text-sm font-semibold mb-2 mt-4 text-primaryBlue">
                          {t("Upgrade Plan Details")}
                        </h3>

                        <div className="text-sm text-gray-700 space-y-2 border-b-2 border-[#C6C6C680] mt-2 pb-3">
                          <div className="flex justify-between">
                            <span className=" text-sm font-medium">
                              {t("Remaining Days")}
                            </span>
                            <span className=" text-sm font-medium">
                              {ugradePlanDetails?.current_plan_due_days}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className=" text-sm font-medium">
                              {t("New Plan Price")}
                            </span>
                            <span className=" text-sm font-medium">
                              EGP{" "}
                              {ugradePlanDetails?.new_plan_actual_price?.toFixed(
                                2
                              )}
                            </span>
                          </div>
                          {ugradePlanDetails?.additional_per_device_security_deposit >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {t("Security Deposit")}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {isUpgrade
                                  ? ugradePlanDetails?.additional_per_device_security_deposit?.toFixed(
                                      2
                                    )
                                  : selectedPlan?.per_device_security_deposit?.toFixed(
                                      2
                                    )}
                              </span>
                            </div>
                          )}
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {t("Adjusted Amount")}
                            </span>
                            <span className=" text-sm font-medium">
                              EGP -
                              {ugradePlanDetails?.total_remaining_amount?.toFixed(
                                2
                              )}
                            </span>
                          </div>
                          <div className="flex justify-between mb-2">
                            <span className=" text-sm font-medium">
                              {t("Plan Amount")}
                            </span>
                            <span className=" text-sm font-medium">
                              EGP{" "}
                              {ugradePlanDetails?.new_plan_price?.toFixed(2)}
                            </span>
                          </div>
                          {users *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_user_price
                              : selectedPlan?.per_user_price) >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {`${t("Add-on users")} (${users})`}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {users *
                                  (isUpgrade
                                    ? ugradePlanDetails?.additional_per_user_price?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.per_user_price?.toFixed(2))}
                              </span>
                            </div>
                          )}

                          {branches *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_branch_price
                              : selectedPlan?.per_branch_price) >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {`${t("Add-on Branches")} (${branches})`}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {branches *
                                  (isUpgrade
                                    ? ugradePlanDetails?.additional_per_branch_price?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.per_branch_price?.toFixed(
                                        2
                                      ))}
                              </span>
                            </div>
                          )}
                          {warehousesCount *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_warehouse_price
                              : selectedPlan?.per_warehouse_price) >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {`${t(
                                  "Add-on warehouses"
                                )} (${warehousesCount})`}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {warehousesCount *
                                  (isUpgrade
                                    ? ugradePlanDetails?.additional_per_warehouse_price?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.per_warehouse_price?.toFixed(
                                        2
                                      ))}
                              </span>
                            </div>
                          )}

                          {devices *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_device_price
                              : selectedPlan?.per_device_monthly_amount) >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {`${t("Add-on machines")} (${devices})`}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {devices *
                                  (isUpgrade
                                    ? ugradePlanDetails?.additional_per_device_price?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.per_device_monthly_amount?.toFixed(
                                        2
                                      ))}
                              </span>
                            </div>
                          )}
                          {devices *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_device_security_deposit
                              : selectedPlan?.per_device_security_deposit) >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {t("Additional Devices Security Deposit")}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {devices *
                                  (isUpgrade
                                    ? ugradePlanDetails?.additional_per_device_security_deposit?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.per_device_security_deposit?.toFixed(
                                        2
                                      ))}
                              </span>
                            </div>
                          )}
                          {appliedCoupon?.coupon_id && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {t("Coupon Discount")}
                              </span>
                              <span className=" text-sm font-medium text-green-600">
                                EGP -{couponDiscount?.toFixed(2)}
                              </span>
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <h3 className="text-sm font-semibold mb-2 mt-4 text-primaryBlue">
                          {t("Plan Details")}
                        </h3>
                        <div className="mt-2 border-b-2 border-[#C6C6C680] pb-3">
                          {!isUpgrade ? (
                            <>
                              <div className="flex justify-between mb-2">
                                <span className=" text-sm font-medium">
                                  {t("Plan Amount")}
                                </span>
                                <span className=" text-sm font-medium">
                                  EGP{" "}
                                  {isUpgrade
                                    ? ugradePlanDetails?.new_plan_price?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.cost?.toFixed(2)}
                                </span>
                              </div>
                              {selectedPlan?.security_deposit > 0 && (
                                <div className="flex justify-between mb-2">
                                  <span className=" text-sm font-medium">
                                    {t("Security Deposit")}
                                  </span>
                                  <span className=" text-sm font-medium">
                                    EGP{" "}
                                    {selectedPlan?.security_deposit?.toFixed(2)}
                                  </span>
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="flex justify-between mb-2">
                                <span className=" text-sm font-medium">
                                  {t("Plan Amount")}
                                </span>
                                <span className=" text-sm font-medium">
                                  EGP{" "}
                                  {ugradePlanDetails?.new_plan_price?.toFixed(
                                    2
                                  )}
                                </span>
                              </div>{" "}
                            </>
                          )}
                          {users *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_user_price
                              : selectedPlan?.per_user_price) >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {`${t("Add-on users")} (${users})`}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {users *
                                  (isUpgrade
                                    ? ugradePlanDetails?.additional_per_user_price?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.per_user_price?.toFixed(2))}
                              </span>
                            </div>
                          )}

                          {branches *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_branch_price
                              : selectedPlan?.per_branch_price) >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {`${t("Add-on branches")} (${branches})`}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {branches *
                                  (isUpgrade
                                    ? ugradePlanDetails?.additional_per_branch_price?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.per_branch_price?.toFixed(
                                        2
                                      ))}
                              </span>
                            </div>
                          )}
                          {warehousesCount *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_warehouse_price
                              : selectedPlan?.per_warehouse_price) >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {`${t(
                                  "Add-on warehouses"
                                )} (${warehousesCount})`}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {warehousesCount *
                                  (isUpgrade
                                    ? ugradePlanDetails?.additional_per_warehouse_price?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.per_warehouse_price?.toFixed(
                                        2
                                      ))}
                              </span>
                            </div>
                          )}

                          {devices *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_device_price
                              : selectedPlan?.per_device_monthly_amount) >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {`${t("Add-on machines")} (${devices})`}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {devices *
                                  (isUpgrade
                                    ? ugradePlanDetails?.additional_per_device_price?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.per_device_monthly_amount?.toFixed(
                                        2
                                      ))}
                              </span>
                            </div>
                          )}
                          {devices *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_device_security_deposit
                              : selectedPlan?.per_device_security_deposit) >
                            0 && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {t("Additional Devices Security Deposit")}
                              </span>
                              <span className=" text-sm font-medium">
                                EGP{" "}
                                {devices *
                                  (isUpgrade
                                    ? ugradePlanDetails?.additional_per_device_security_deposit?.toFixed(
                                        2
                                      )
                                    : selectedPlan?.per_device_security_deposit?.toFixed(
                                        2
                                      ))}
                              </span>
                            </div>
                          )}
                          {appliedCoupon?.coupon_id && (
                            <div className="flex justify-between mb-2">
                              <span className=" text-sm font-medium">
                                {t("Coupon Discount")}
                              </span>
                              <span className=" text-sm font-medium text-green-600">
                                EGP -{couponDiscount?.toFixed(2)}
                              </span>
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    <div className="flex justify-between mt-3 ">
                      <span className="text-base font-semibold flex items-center gap-2">
                        {t("Amount to Pay")}
                        {isUpgrade && (
                          <Tooltip
                            title={t(
                              "This is the total amount you need to pay including all charges"
                            )}
                          >
                            <IconButton size="small" className="p-0">
                              <InfoOutlinedIcon
                                fontSize="small"
                                sx={{ color: "#383636" }}
                              />
                            </IconButton>
                          </Tooltip>
                        )}
                      </span>
                      <span className=" text-base font-semibold">
                        EGP {(totalUpdatePrice - couponDiscount)?.toFixed(2)}
                      </span>
                    </div>
                  </>
                )}
              </div>
              {/* </> */}
              {/* )} */}

              {isUpgrade ? (
                <div className="flex justify-center">
                  <button
                    // onClick={() => {
                    //   totalUsers < selectedUsers?.length
                    //     ? setShowUsers(true)
                    //     : handleUpgradePayment();
                    // }}
                    onClick={() => {
                      if (totalUsers < selectedUsers?.length) {
                        setShowUsers(true);
                      } else if (totalBranches < selectedBranches?.length) {
                        setShowBranches(true);
                      } else if (totalWareHouses < selectedWarehouse?.length) {
                        setShowWarehouses(true);
                      } else {
                        setShowModal(true);
                        setProcessType("upgrade");
                      }
                    }}
                    disabled={
                      loading ||
                      (subscriptionDetails?.status === "active" &&
                        durationRank[subscriptionDetails?.duration] >
                          durationRank[selectedPlan?.billing_type]) ||
                      totalUpdatePrice < 0
                    }
                    className="w-6/12 px-8  py-3 mt-6 bg-primaryBlue text-white rounded-md font-semibold shadow-md  disabled:opacity-50"
                  >
                    {loading ? "Processing..." : `Confirm & Upgrade`}
                  </button>
                </div>
              ) : (
                <>
                  {isPlanActive && diffDays > 2 ? (
                    <div className="mt-6 flex justify-center">
                      <button
                        onClick={() => {
                          setShowModal(true);
                          setProcessType("addFeatures");
                        }}
                        disabled={
                          users *
                            (isUpgrade
                              ? ugradePlanDetails?.additional_per_user_price
                              : selectedPlan?.per_user_price) +
                            devices *
                              (isUpgrade
                                ? ugradePlanDetails?.additional_per_device_price
                                : selectedPlan?.per_device_monthly_amount) +
                            branches *
                              (isUpgrade
                                ? ugradePlanDetails?.additional_per_branch_price
                                : selectedPlan?.per_branch_price) +
                            warehousesCount *
                              (isUpgrade
                                ? ugradePlanDetails?.additional_per_warehouse_price
                                : selectedPlan?.per_warehouse_price) +
                            devices *
                              (isUpgrade
                                ? ugradePlanDetails?.additional_per_device_security_deposit
                                : selectedPlan?.per_device_security_deposit) <=
                            0 ||
                          usersLoading ||
                          loading ||
                          (subscriptionDetails?.duration
                            ? subscriptionDetails?.duration !=
                              selectedPlan?.billing_type
                            : false)
                        }
                        className="w-6/12 px-8 py-3 bg-primaryBlue text-white rounded-md font-semibold shadow-md  disabled:opacity-50"
                      >
                        {usersLoading || loading
                          ? t("Processing...")
                          : t(`Confirm & Pay`)}
                      </button>
                    </div>
                  ) : (
                    <div className="mt-6 flex justify-center">
                      <button
                        onClick={() => {
                          if (totalUsers < selectedUsers?.length) {
                            setShowUsers(true);
                          } else if (totalBranches < selectedBranches?.length) {
                            setShowBranches(true);
                          } else if (
                            totalWareHouses < selectedWarehouse?.length
                          ) {
                            setShowWarehouses(true);
                          } else {
                            setShowModal(true);
                            setProcessType("renew");
                          }
                        }}
                        // onClick={() => {
                        //   totalUsers < selectedUsers?.length
                        //     ?

                        //     setShowUsers(true)
                        //     : handlePayment();
                        // }}
                        disabled={usersLoading || loading}
                        className="w-6/12 px-8 py-3 bg-primaryBlue text-white rounded-md font-semibold shadow-md  disabled:opacity-50"
                      >
                        {usersLoading || loading
                          ? t("Processing...")
                          : `${t("Continue with")} ${t(
                              plans[selectedType]?.plan_name
                            )} ${t("Plan")}`}
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>

            <Drawer
              title={t("Warehouses")}
              placement={i18n.language === "ar" ? "left" : "right"}
              width={500}
              onClose={() => setShowWarehouses(false)}
              open={showWarehouse}
              styles={{
                header: {
                  color: "#1E3ABA",
                  fontWeight: "bold",
                  fontSize: "20px",
                },
              }}
            >
              {allWarehouses?.length > 0 ? (
                <>
                  <div className="space-y-4">
                    {/* Search Input */}

                    <SearchBox
                      // showBarcode={true}
                      searchResult={(values) => setSearchTerm(values)}
                      placeholder={t("Search Warehouse")}
                      width={"100%"}
                    />
                    {selectedWarehouse?.length > totalWareHouses && (
                      <>
                        {" "}
                        <h4 className="text-base font-semibold mt-2">{`${t(
                          "Remove"
                        )} ${selectedWarehouse?.length - totalWareHouses} ${
                          selectedWarehouse?.length - totalWareHouses == 1
                            ? t("Warehouse")
                            : t("Warehouses")
                        }`}</h4>
                      </>
                    )}
                    {allWarehouses
                      ?.filter((user) =>
                        user.store_name
                          .toLowerCase()
                          .includes(searchTerm.toLowerCase())
                      )
                      // ?.filter((user) => user.active) // only active users
                      // .filter((user) =>
                      //   user.store_name.toLowerCase().includes(searchTerm.toLowerCase())
                      // )
                      .map((user, idx) => {
                        const isSelected = selectedWarehouse.some(
                          (u) => u.store_id === user.store_id
                        );

                        return (
                          <div
                            key={idx}
                            className="flex items-center justify-between p-3 border-b rounded-lg"
                          >
                            {/* Avatar + User Info */}
                            <div className="flex items-center space-x-3">
                              {/* <div className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden">
                                {user?.image_url?.length >= 30 ? (
                                  <img
                                    className="w-10 h-10 object-cover rounded-full"
                                    src={user.image_url}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    className="h-16 w-16 object-cover rounded-full ms-4"
                                    src={noImage}
                                    alt=""
                                  />
                                )}
                              </div> */}
                              <div>
                                <p className="font-semibold">
                                  {user.store_name}
                                </p>
                              </div>
                            </div>

                            {/* Add / Remove Button */}
                            {isSelected ? (
                              <button
                                onClick={() =>
                                  setSelectedWarehouses((prev) =>
                                    prev.filter(
                                      (u) => u.store_id !== user.store_id
                                    )
                                  )
                                }
                                className="px-4 py-1 text-white rounded-lg text-sm font-medium bg-[#EB3E27]"
                              >
                                {t("Remove")}
                              </button>
                            ) : (
                              <button
                                onClick={() =>
                                  setSelectedWarehouses((prev) => [
                                    ...prev,
                                    user,
                                  ])
                                }
                                className="px-4 py-1 text-white rounded-lg text-sm font-medium bg-primaryBlue"
                              >
                                {t("Add")}
                              </button>
                            )}
                          </div>
                        );
                      })}
                  </div>

                  {/* Save Button */}
                  <div className="mt-6">
                    <button
                      onClick={() => setShowWarehouses(false)}
                      disabled={selectedWarehouse?.length > allWarehouses}
                      className={`w-full px-8 py-3 rounded-xl font-semibold transition bg-primaryBlue text-white cursor-pointer disabled:opacity-50`}
                    >
                      {t("Save")}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex justify-center items-center">
                    <p>{t("No warehouse found.")}</p>
                  </div>
                </>
              )}
            </Drawer>

            <Drawer
              title={t("Branches")}
              placement={i18n.language === "ar" ? "left" : "right"}
              width={500}
              onClose={() => setShowBranches(false)}
              open={showBranches}
              styles={{
                header: {
                  color: "#1E3ABA",
                  fontWeight: "bold",
                  fontSize: "20px",
                },
              }}
            >
              {subStores?.length > 0 ? (
                <>
                  <div className="space-y-4">
                    {/* Search Input */}

                    <SearchBox
                      // showBarcode={true}
                      searchResult={(values) => setSearchTerm(values)}
                      placeholder={t("Search Branch")}
                      width={"100%"}
                    />
                    {selectedBranches?.length > totalBranches && (
                      <>
                        {" "}
                        <h4 className="text-base font-semibold mt-2">{`${t(
                          "Remove"
                        )} ${selectedBranches?.length - totalBranches} ${
                          selectedBranches?.length - totalBranches == 1
                            ? t("Branch")
                            : t("Branches")
                        }`}</h4>
                      </>
                    )}
                    {subStores
                      ?.filter((user) =>
                        user.store_name
                          .toLowerCase()
                          .includes(searchTerm.toLowerCase())
                      )
                      // ?.filter((user) => user.active) // only active users
                      // .filter((user) =>
                      //   user.store_name.toLowerCase().includes(searchTerm.toLowerCase())
                      // )
                      .map((user, idx) => {
                        const isSelected = selectedBranches.some(
                          (u) => u.store_id === user.store_id
                        );

                        return (
                          <div
                            key={idx}
                            className="flex items-center justify-between p-3 border-b rounded-lg"
                          >
                            {/* Avatar + User Info */}
                            <div className="flex items-center space-x-3">
                              {/* <div className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden">
                                {user?.image_url?.length >= 30 ? (
                                  <img
                                    className="w-10 h-10 object-cover rounded-full"
                                    src={user.image_url}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    className="h-16 w-16 object-cover rounded-full ms-4"
                                    src={noImage}
                                    alt=""
                                  />
                                )}
                              </div> */}
                              <div>
                                <p className="font-semibold">
                                  {user.store_name}
                                </p>
                              </div>
                            </div>

                            {/* Add / Remove Button */}
                            {isSelected ? (
                              <button
                                onClick={() =>
                                  setSelectedBranches((prev) =>
                                    prev.filter(
                                      (u) => u.store_id !== user.store_id
                                    )
                                  )
                                }
                                className="px-4 py-1 text-white rounded-lg text-sm font-medium bg-[#EB3E27]"
                              >
                                {t("Remove")}
                              </button>
                            ) : (
                              <button
                                onClick={() =>
                                  setSelectedBranches((prev) => [...prev, user])
                                }
                                className="px-4 py-1 text-white rounded-lg text-sm font-medium bg-primaryBlue"
                              >
                                {t("Add")}
                              </button>
                            )}
                          </div>
                        );
                      })}
                  </div>

                  {/* Save Button */}
                  <div className="mt-6">
                    <button
                      onClick={() => setShowBranches(false)}
                      disabled={selectedBranches?.length > subStores}
                      className={`w-full px-8 py-3 rounded-xl font-semibold transition bg-primaryBlue text-white cursor-pointer disabled:opacity-50`}
                    >
                      {t("Save")}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex justify-center items-center">
                    <p>{t("No branch found.")}</p>
                  </div>
                </>
              )}
            </Drawer>

            <Drawer
              title={t("Users")}
              placement={i18n.language === "ar" ? "left" : "right"}
              width={500}
              onClose={() => setShowUsers(false)}
              open={showUsers}
              styles={{
                header: {
                  color: "#1E3ABA",
                  fontWeight: "bold",
                  fontSize: "20px",
                },
              }}
            >
              {allUsers?.length > 0 ? (
                <>
                  <div className="space-y-4">
                    {/* Search Input */}

                    <SearchBox
                      // showBarcode={true}
                      searchResult={(values) => setSearchTerm(values)}
                      placeholder={t("Search Users")}
                      width={"100%"}
                    />
                    {selectedUsers?.length > totalUsers && (
                      <>
                        {" "}
                        <h4 className="text-base font-semibold mt-2">{`${t(
                          "Remove"
                        )} ${selectedUsers?.length - totalUsers} ${
                          selectedUsers?.length - totalUsers == 1
                            ? t("User")
                            : t("Users")
                        }`}</h4>
                      </>
                    )}
                    {allUsers
                      ?.filter((user) => user.active) // only active users
                      .filter((user) =>
                        user.name
                          .toLowerCase()
                          .includes(searchTerm.toLowerCase())
                      ) // filter by search term
                      .map((user, idx) => {
                        const isSelected = selectedUsers.some(
                          (u) => u.user_id === user.user_id
                        );

                        return (
                          <div
                            key={idx}
                            className="flex items-center justify-between p-3 border-b rounded-lg"
                          >
                            {/* Avatar + User Info */}
                            <div className="flex items-center space-x-3">
                              <div className="w-10 h-10 rounded-full bg-gray-200 overflow-hidden">
                                {user?.image_url?.length >= 30 ? (
                                  <img
                                    className="w-10 h-10 object-cover rounded-full"
                                    src={user.image_url}
                                    alt=""
                                  />
                                ) : (
                                  <img
                                    className="h-16 w-16 object-cover rounded-full ms-4"
                                    src={noImage}
                                    alt=""
                                  />
                                )}
                              </div>
                              <div>
                                <p className="font-semibold">{user.name}</p>
                                <p className="text-xs text-gray-500">
                                  {user.user_type == "online_pos"
                                    ? t("POS User")
                                    : t("Online User")}
                                </p>
                              </div>
                            </div>

                            {/* Add / Remove Button */}
                            {isSelected ? (
                              <button
                                onClick={() =>
                                  setSelectedUsers((prev) =>
                                    prev.filter(
                                      (u) => u.user_id !== user.user_id
                                    )
                                  )
                                }
                                className="px-4 py-1 text-white rounded-lg text-sm font-medium bg-[#EB3E27]"
                              >
                                {t("Remove")}
                              </button>
                            ) : (
                              <button
                                onClick={() =>
                                  setSelectedUsers((prev) => [...prev, user])
                                }
                                className="px-4 py-1 text-white rounded-lg text-sm font-medium bg-primaryBlue"
                              >
                                {t("Add")}
                              </button>
                            )}
                          </div>
                        );
                      })}
                  </div>

                  {/* Save Button */}
                  <div className="mt-6">
                    <button
                      onClick={() => setShowUsers(false)}
                      disabled={selectedUsers?.length > totalUsers}
                      className={`w-full px-8 py-3 rounded-xl font-semibold transition bg-primaryBlue text-white cursor-pointer disabled:opacity-50`}
                    >
                      {t("Save")}
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex justify-center items-center">
                    <p>{t("No users found.")}</p>
                  </div>
                </>
              )}
            </Drawer>

            {/* Modal */}
            {showModal && (
              <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 px-4">
                <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl px-8 pb-7 relative transition-all">
                  {/* Close Button */}
                  {(step == 1 || step == 2) && (
                    <button
                      onClick={() => {
                        setStep(1);
                        setReferenceId(null);
                        setShowModal(false);
                        setSelectedGateway(null);
                        setPaymentMode("");
                      }}
                      className="absolute top-6 end-4 text-gray-500 hover:text-gray-800 text-2xl"
                    >
                      ✕
                    </button>
                  )}

                  {/* Step 1: Select Gateway */}
                  {step === 1 && (
                    <>
                      <h2 className="text-xl font-semibold mb-6 text-start mt-6">
                        {t("Select Payment Gateway")}
                      </h2>

                      <div className="space-y-3">
                        {gateways.map((gateway) => (
                          <div
                            key={gateway.id}
                            onClick={() => {
                              if (gateway.name == "PayMob") {
                                setStep(2);
                              }
                              setSelectedGateway(gateway.id);
                            }}
                            className={`flex items-center justify-between p-4 hover:bg-blue-50 rounded-2xl cursor-pointer transition-all ${
                              selectedGateway === gateway.id
                                ? "bg-blue-50 "
                                : "border-gray-300 "
                            }`}
                          >
                            <div className="flex items-center gap-3">
                              <span className="text-xl">{gateway.logo}</span>
                              <span className="font-medium text-lg">
                                {t(gateway.name)}
                              </span>
                            </div>
                            <div
                              className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                                selectedGateway === gateway.id
                                  ? "border-blue-600"
                                  : "border-gray-400"
                              }`}
                            >
                              {selectedGateway === gateway.id && (
                                <div className="w-2.5 h-2.5 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                      {selectedGateway == "Fawry" && (
                        <button
                          onClick={() => handleFawryPayment(null, processType)}
                          className="w-full mt-6 bg-primaryBlue text-white py-3 rounded-2xl font-semibold hover:bg-blue-900 transition"
                        >
                          {usersLoading || loading
                            ? t("Processing...")
                            : t("Proceed")}
                        </button>
                      )}
                    </>
                  )}

                  {/* Step 2: PayMob Options */}
                  {(step === 2 || step == 4) &&
                    selectedGateway === "PayMob" && (
                      <>
                        <div className="flex gap-4 items-center">
                          <button
                            onClick={() => {
                              setStep(1);
                              setPaymentMode("");
                              setSelectedGateway(null);
                            }}
                            className="text-xl font-bold text-gray-600"
                          >
                            {i18n.language === "ar" ? (
                              <FaArrowRight />
                            ) : (
                              <FaArrowLeft />
                            )}
                          </button>
                          <h2 className="text-xl font-semibold text-start mb-6 mt-6">
                            {t("Select Payment Method")}
                          </h2>
                        </div>

                        <div className="flex justify-between mb-5">
                          {/* <button
                            disabled={step == 4}
                            onClick={() => setPaymentMode("card")}
                            className={`py-7 rounded-xl border flex  w-[48%] items-center px-4 text-lg font-medium disabled:opacity-50 hover:bg-blue-50
                            ${
                              paymentMode == "card"
                                ? "border-blue-500 bg-blue-50"
                                : "border-gray-300"
                            }`}
                          >
                            <div
                              className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                                paymentMode == "card"
                                  ? "border-blue-600"
                                  : "border-gray-400"
                              }`}
                            >
                              {paymentMode == "card" && (
                                <div className="w-2.5 h-2.5 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                            <span className=" ms-10">{t("Card")}</span>
                          </button> */}

                          <button
                            disabled={step == 4}
                            onClick={() => setPaymentMode("wallet")}
                            className={`py-7 rounded-xl border flex w-[48%] items-center px-4 text-lg font-medium disabled:opacity-50 hover:bg-blue-50
                            ${
                              paymentMode == "wallet"
                                ? "border-primaryBlue bg-blue-50"
                                : "border-gray-300"
                            }`}
                          >
                            <div
                              className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                                paymentMode === "wallet"
                                  ? "border-blue-600"
                                  : "border-gray-400"
                              }`}
                            >
                              {paymentMode === "wallet" && (
                                <div className="w-2.5 h-2.5 bg-blue-600 rounded-full"></div>
                              )}
                            </div>
                            <span className="ms-10">{t("Wallet")}</span>
                          </button>
                        </div>
                        {step != 4 && (
                          <button
                            disabled={step == 4 || paymentMode == ""}
                            onClick={() => {
                              handlePaymobPayment(paymentMode, processType);
                              //   setShowModal(false);
                              // navigate("/settings/subscription");
                            }}
                            className="px-8 py-3 bg-primaryBlue text-white rounded-xl mt-6 w-full font-semibold transition disabled:opacity-50"
                          >
                            {usersLoading || loading
                              ? t("Processing...")
                              : t("Proceed")}
                          </button>
                        )}

                        {step == 4 && (
                          <button
                            onClick={() => {
                              setShowModal(false);
                              navigate("/settings/subscription");
                            }}
                            className="px-8 py-3 bg-primaryBlue text-white w-full rounded-xl mt-6 font-semibold transition"
                          >
                            {t("Continue")}
                          </button>
                        )}
                        {/* {step != 4 && 
                    <button
                        onClick={() => setStep(1)}
                        className="mt-6 text-sm text-gray-600 hover:underline"
                      >
                        ← Back to gateways
                      </button>
                   } */}
                      </>
                    )}

                  {/* Step 3: Fawry Reference */}
                  {step === 3 && (
                    <div className="text-center mt-6">
                      <h2 className="text-2xl font-bold mb-4">
                        {t("Payment Reference")}
                      </h2>

                      {loading ? (
                        <p className="text-gray-600 mb-6">
                          {t("Generating your reference ID...")}
                        </p>
                      ) : (
                        <>
                          <p className="text-gray-700 mb-8 text-lg">
                            {t("Your Fawry payment reference ID is")}:{" "}
                            <span className="font-semibold text-blue-600 text-xl block mt-2">
                              {referenceId}
                            </span>
                          </p>

                          <button
                            onClick={() => {
                              setShowModal(false);
                              navigate("/settings/subscription");
                            }}
                            className="px-8 py-3 bg-green-600 text-white rounded-xl font-semibold hover:bg-green-700 transition"
                          >
                            {t("Proceed")}
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <PaymentModal
          visible={paymentModal}
          onClose={() => {
            setStep(1);
            setSelectedGateway(null);
            setPaymentMode("");
            setPaymentModal(false);
          }}
          checkoutUrl={paymentUrl}
          navigate={navigate}
          handleConfirm={() => {
            setShowModal(false);
            setPaymentModal(false);
            navigate("/settings/subscription");
          }}
        />
      </div>
    </>
  );
};

export default RenewPlan;
